import { ComponentType, FC, ReactNode } from 'react';
import { Item } from './components/Item';

import styles from './index.module.css';

interface MenuItem {
  id?: string | number;
  link: string;
  title: string;
  iKey?: string;
  items?: MenuItem[];
}

interface MenuProps {
  items?: MenuItem[];
  NavLink: ComponentType<{ to: string; children: ReactNode }>;
  isTop?: boolean;
  className?: string;
}

export const Menu: FC<MenuProps> = ({
  items: menuItems = [],
  NavLink,
  isTop = false,
  className = ''
}) => (
  <ul className={`${styles.menu} ${className}`}>
    {menuItems.map((item) => {
      const { link, iKey = '', title, items = [] } = item;

      return (
        <Item
          key={`${link}${title}${iKey}`}
          item={item}
          isTop={isTop}
          NavLink={NavLink}
          menu={<Menu items={items} NavLink={NavLink} />}
        />
      );
    })}
  </ul>
);
